/**
 * employerPlanLabels.js — frontend mapping from catalogue
 * `plan_tier` to display labels.
 *
 * F.4.4.DOCTRINE-CORRECTION (2026-02-26):
 * Display labels now match the catalogue plan_tier identifiers
 * directly:
 *
 *   starter      → "Starter"
 *   professional → "Professional"
 *   business     → "Business"
 *   enterprise   → "Enterprise"
 *
 * Prior mapping used brand-continuity names (Base / Focus / Flow)
 * but those clashed with the catalogue plan cards and led to
 * operator-visible inconsistency ("topbar says Base but I'm on
 * Starter"). The backend constraint on plan_tier is unchanged
 * (mig 082); only the FE label layer is corrected.
 *
 * Beta posture: pricing copy stays "placeholder" until F.4.6
 * cutover flips EMP_STRIPE_FEATURE_FLAG. No invoice display, no
 * overage rate display, no upgrade CTA while flag !== 'enabled'.
 */

export const PLAN_TIER_TO_LABEL = {
  starter:      'Starter',
  professional: 'Professional',
  business:     'Business',
  enterprise:   'Enterprise',
};

export const PLAN_TIER_SUBTITLE = {
  starter:      'Free baseline · evaluation layer',
  professional: 'Active recruiting teams',
  business:     'Scale-stage hiring teams',
  enterprise:   'Admin-provisioned · institutional deployment',
};

export const PLACEHOLDER_LABEL = 'Starter';
export const PLACEHOLDER_SUBTITLE = 'Free baseline · evaluation layer';

/** Display the plan label given a tier string (or null/undefined
 *  → "Starter" / placeholder). */
export function planLabel(tier) {
  if (!tier) return PLACEHOLDER_LABEL;
  return PLAN_TIER_TO_LABEL[tier] || tier;
}

export function planSubtitle(tier) {
  if (!tier) return PLACEHOLDER_SUBTITLE;
  return PLAN_TIER_SUBTITLE[tier] || '';
}
